export default customElements.define('w-modal', class Modal extends wealthify.CustomElementBaseClass {
    constructor () {
        const styleSelector = 'c-modal';
        const config = {
            styleSelector: styleSelector,
            templateHTML: `
                <div class="${styleSelector}__container" data-root>
                    <div class="${styleSelector}__overlay" data-overlay></div>
                    <div class="${styleSelector}__body" role="dialog" data-body>
                        <w-widget-button label="Close modal" icon="cross" class="${styleSelector}__close-button" data-close></w-widget-button>
                        <h2 class="${styleSelector}__heading" data-heading></h2>
                        <div class="${styleSelector}__main" data-child-root></div>
                    </div>
                </div>`,
            hasChildren: true,
            cacheDom: [ 'data-overlay', 'data-body', 'data-close', 'data-heading' ]
        };

        super(config);

        this.lastFocus = null;

        this.onConnectedCallback = () => {
            this.classList.add(this.styleSelector);
            this.dom.close.addEventListener('click', () => this.open = false);
            this.dom.overlay.addEventListener('click', () => this.open = false);
            this.dom.body.addEventListener('keydown', (event) => this._closeModalWithEscape(event, this), true);
            document.addEventListener('focus', (event) => this._restrictFocusWhileModalOpen(event, this), true);
        };
    }

    static get variantEnums() {
        return {
            Default: 'default',
            Takeover:'takeover'
        };
    }

    // TODO: Close event to be incorporated into Container base class
    // Ticket number: PDB-1011
    static get eventSettings () {
        return {events: {Close: 'container-close',}};
    }

    static get observedProps () {
        return [
            new wealthify.Prop('heading', {required: true}),
            new wealthify.Prop('open', {
                default: false,
                type: wealthify.propTypes.Boolean()
            }),
            new wealthify.Prop('dismissible', {
                default: true,
                type: wealthify.propTypes.Boolean()
            }),
            new wealthify.Prop('cancel-refocus', {
                default: false, 
                type: wealthify.propTypes.Boolean()
            }),
            new wealthify.Prop('variant', {
                default: this.variantEnums.Default,
                type: wealthify.propTypes.ArrayItem(Object.values(this.variantEnums))
            })
        ];
    }

    get propCallbacks() {
        return {
            heading: () => {
                this.dom.heading.innerHTML = this.heading;
            },
            open: () => {
                const callback = this.open ? '_openModal' : '_closeModal';

                this[callback]();
            },
            dismissible: () => {
                const classListAction = this.dismissible ? 'remove' : 'add';
                
                this.dom.close.classList[classListAction]('u-display__none');
            },
            cancelRefocus: () => {},
            variant: () => {
                Object.values(this.constructor.variantEnums).forEach((variant) => this.classList.remove(`${this.styleSelector}--variant-${variant}`));    
                this.classList.add(`${this.styleSelector}--variant-${this.variant}`);
            }
        };
    }

    _openModal () {
        this.lastFocus = document.activeElement;
        this._toggleModal();

        this.dom.body.setAttribute('tabindex', '0');
        this.dom.body.removeAttribute('aria-hidden');
        this.dom.body.removeAttribute('hidden');
        this.dom.body.focus();
    }

    _closeModal (component) {
        component = component || this;
        component._toggleModal();
        component.dom.body.removeAttribute('tabindex');
        component.dom.body.setAttribute('aria-hidden', true);
        component.dom.body.setAttribute('hidden', true);

        component.events.Close.dispatch(null, true);

        if (component.lastFocus && !this.cancelRefocus){
            component.lastFocus.focus();
        }
    }

    _toggleModal () {
        const classListAction = this.open ? 'add' : 'remove';
        const bodyOverflow = this.open ? 'hidden' : '';

        document.body.style.overflow = bodyOverflow;
        this.classList[classListAction](`${this.styleSelector}--open`);
        this.dom.body.classList[classListAction](`${this.styleSelector}__body--open`);
        this.dom.overlay.classList[classListAction](`${this.styleSelector}__overlay--open`);
    }

    _closeModalWithEscape (event, component) {
        if (event.keyCode === 27) {
            component.open = false;
        }
    }

    _restrictFocusWhileModalOpen (event, component) {
        if (component.open && !component.contains(event.target)) {
            event.stopPropagation();
            component.dom.body.focus();
        }
    }
});